<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import FileUpload from '@/components/FileUpload';

import Lecture from './Lecture';
import { IRI } from '@/api';

export default {
  name: 'ModuleCoursesEdition',
  components: {
    CKEditor: CKEditor.component,
    Lecture,
    FileUpload,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
    };
  },
  computed: {
    ...mapState('course/item', [
      'item',
    ]),
    ...mapState('company/collection', {
      companies: 'items',
    }),
    ...mapState('exam/collection', {
      exams: 'items',
    }),
    cover: {
      get () {
        return this.item.cover;
      },
      set (value) {
        const { item } = this;
        item.cover = value;
        this.setItem(item);
      },
    },
    company: {
      get () {
        if (!this.item.company || !this.item.company.id) {
          return '';
        }
        return this.item.company.id;
      },
      set (value) {
        const { item } = this;
        item.company = { id: value };
        this.setItem(item);
      },
    },
    exam: {
      get () {
        if (!this.item.exam) {
          return '';
        }
        return this.item.exam.id;
      },
      set (value) {
        const { item } = this;
        // item.exam = `${IRI.exam}${value}`;
        if (value) {
          item.exam = { id: value };
        }
        else {
          item.exam = null;
        }
        this.setItem(item);
      },
    },
    title: {
      get () {
        return this.item.title;
      },
      set (value) {
        const { item } = this;
        item.title = value;
        this.setItem(item);
      },
    },
    content: {
      get () {
        return this.item.content || '';
      },
      set (value) {
        const { item } = this;
        item.content = value;
        this.setItem(item);
      },
    },
    finalWords: {
      get () {
        return this.item.finalWords || '';
      },
      set (value) {
        const { item } = this;
        item.finalWords = value;
        this.setItem(item);
      },
    },
    lectures: {
      get () {
        return this.item.lectures;
      },
      set (value) {
        const { item } = this;
        item.lectures = value;
        this.setItem(item);
      },
    },
  },
  methods: {
    ...mapActions('course/item', [
      'save',
      'fetch',
    ]),
    ...mapMutations('course/item', [
      'setItem',
      'addLecture',
      'removeLecture',
      'reset',
    ]),
    ...mapActions('company/collection', {
      fetchCompanies: 'fetch',
    }),
    ...mapActions('exam/collection', {
      fetchExams: 'fetch',
    }),
    localSave() {
      const payload = {
        name: this.item.name,
      };

      if (this.item.id) {
        payload.id = this.item.id;
      }

      this.save(payload)
        .then(() => {
          // if (payload.id) {
          //   return;
          // }

          this.$router.push({ name: 'courses-listing' });
        })
      ;
    },
  },
  created() {
    const { id } = this.$route.params;

    this.fetchCompanies(false);
    this.fetchExams(false);

    if (!id) {
      this.reset();
      return;
    }

    this.fetch(id);
  },
};
</script>
<template>
  <div>
    <div class="box">
      <h2>General</h2>
      <FileUpload className="form-group pb-3" directory="courses" v-model="cover" label="Cover Image" />
      <div class="form-group mt-3">
        <label for="company" class="d-block">Company</label>
        <select id="company" class="form-control rounded-0" v-model="company">
          <option value="" disabled>Select a Company</option>
          <option v-for="company in companies" :key="company.id" :value="company.id">{{ company.name }}</option>
        </select>
      </div>
      <div class="form-group mt-3">
        <label for="exam" class="d-block">Exam</label>
        <select id="exam" class="form-control rounded-0" v-model="exam">
          <!-- <option value="" disabled>Select an Exam</option> -->
          <option value="">No Exam</option>
          <option v-for="exam in exams" :key="exam.id" :value="exam.id">{{ exam.title }}</option>
        </select>
      </div>
      <div class="form-group mt-3">
        <label for="title" class="d-block">Title</label>
        <input id="title" class="form-control rounded-0" v-model="title" />
      </div>
      <div class="form-group mt-3">
        <label for="content" class="d-block">Content</label>
        <CKEditor id="content" :editor="editor" v-model="content" :config="editorConfig" />
      </div>
      <!-- <div class="form-group mt-3">
        <label for="final_words" class="d-block">Thank You Page</label>
        <CKEditor id="final_words" :editor="editor" v-model="finalWords" :config="editorConfig" />
      </div> -->
    </div>

    <Lecture v-for="(lecture, index) in lectures" :key="index" :order="index" :item="lecture" />

    <div class="box mt-3">
      <div class="d-flex justify-content-between">
        <button class="btn btn-danger" @click="addLecture()">Add Lecture</button>
        <button class="btn btn-primary" @click="localSave">Save</button>
      </div>
    </div>
  </div>
</template>
